import { useEffect, useState } from "react";
import { onLoadingChange } from "../lib/api-events";

export function LoadingBar() {
  const [loading, setLoading] = useState(false);

  useEffect(() => onLoadingChange(setLoading), []);

  if (!loading) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-1">
      <div className="h-full w-full animate-pulse bg-ember" />
    </div>
  );
}
